<template>
  <div id="colorado-route">
    <h1>I CAME ALONG THESE HILLS</h1>
    <img src="../assets/img/colorado_route.jpg" alt="River Gorge">
    <div>Murchison River Gorge, Kalbarri, Western Australia, 1987</div>
    <div class="textbox">
      <div class="row">
        <div class="col">
          <p>…</p>
          <p>To me was all in all.—I cannot paint</p>
          <p>What then I was. The sounding cataract</p>
          <p>Haunted me like a passion: the tall rock,</p>
          <p>The mountain, and the deep and gloomy wood,</p>
          <p>Their colours and their forms, were then to me</p>
          <p>An appetite; a feeling and a love,</p>
          <p>That had no need of a remoter charm,</p>
          <p>By thought supplied, not any interest</p>
          <p>Unborrowed from the eye.—That time is past,</p>
          <p>And all its aching joys are now no more,</p>
          <p>And all its dizzy raptures. Not for this</p>
          <p>Faint I, nor mourn nor murmur; other gifts</p>
          <p>Have followed; for such loss, I would believe,</p>
          <p>Abundant recompense. For I have learned</p>
          <p>To look on nature, not as in the hour</p>
          <p>Of thoughtless youth; but hearing oftentimes</p>
          <p>The still sad music of humanity,</p>
          <p>Nor harsh nor grating, though of ample power</p>
          <p>To chasten and subdue.—And I have felt</p>
        </div>
        <div class="col">
          <p class="placeholder"></p>
          <p>A presence that disturbs me with the joy</p>
          <p>Of elevated thoughts; a sense sublime</p>
          <p>Of something far more deeply interfused,</p>
          <p>Whose dwelling is the light of setting suns,</p>
          <p>And the round ocean and the living air,</p>
          <p>And the blue sky, and in the mind of man:</p>
          <p>A motion and a spirit, that impels</p>
          <p>All thinking things, all objects of all thought,</p>
          <p>And rolls through all things. Therefore am I still</p>
          <p>A lover of the meadows and the woods</p>
          <p>And mountains; and of all that we behold</p>
          <p>From this green earth; of all the mighty world</p>
          <p>Of eye, and ear,—both what they half create,</p>
          <p>And what perceive; well pleased to recognise</p>
          <p>In nature and the language of the sense</p>
          <p>The anchor of my purest thoughts, the nurse,</p>
          <p>The guide, the guardian of my heart, and soul</p>
          <p>Of all my moral being.</p>
          <p>…</p>
        </div>
      </div>
      <div class="source">
        <p>by William Wordsworth, </p>
        <p>Lines Composed a Few Miles above Tintern Abbey, On Revisiting the Banks of the Wye during a Tour. July 13, 1798</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ColoradoRoute'
}

</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
  }
  .textbox {
    margin: 70px 0;
    .row {
      display: flex;
      .col {
        flex: 1;
        .placeholder {
          height: 18px;
        }
        &:last-child {
          border-left: 1px solid black;
          padding-left: 20px;
        }
        p:first-child {
          margin-top: 0;
        }
      }
    }
    .source {
      margin-top: 70px;
    }
  }

  @media all and (max-width: 999px) {
    .textbox {
      .row {
        flex-flow: column;
        .col {
          .placeholder {
            height: 0;
          }
          &:last-child {
            border: none;
            padding-left: 0;
          }
          p:first-child {
            margin-top: -18px;
          }
        }
      }
      .source {
        margin-top: 40px;
      }
    }
  }
</style>
